import { render, staticRenderFns } from "./StuForgotPassword.vue?vue&type=template&id=e7773f44&scoped=true"
import script from "./StuForgotPassword.vue?vue&type=script&lang=js"
export * from "./StuForgotPassword.vue?vue&type=script&lang=js"
import style0 from "./StuForgotPassword.vue?vue&type=style&index=0&id=e7773f44&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e7773f44",
  null
  
)

export default component.exports